/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TransactionCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, PagedModelTransactionDto, TransactionType, PagedModelTransactionDetailedDto } from "../models";

@Injectable({ providedIn: "root" })
export class TransactionCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getTransactions(page?: number, size?: number, idPartner?: number, startDate?: string, endDate?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelTransactionDto>;
    getTransactions(page?: number, size?: number, idPartner?: number, startDate?: string, endDate?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelTransactionDto>>;
    getTransactions(page?: number, size?: number, idPartner?: number, startDate?: string, endDate?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelTransactionDto>>;
    getTransactions(page?: number, size?: number, idPartner?: number, startDate?: string, endDate?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/transactions`;

        let params = new HttpParams();
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }
        if (idPartner != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idPartner, 'idPartner');
        }
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTransactionTypes(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TransactionType>>;
    getTransactionTypes(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TransactionType>>>;
    getTransactionTypes(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TransactionType>>>;
    getTransactionTypes(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/transactions/types`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getDetailedCompense(page?: number, size?: number, startDate?: string, endDate?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelTransactionDetailedDto>;
    getDetailedCompense(page?: number, size?: number, startDate?: string, endDate?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelTransactionDetailedDto>>;
    getDetailedCompense(page?: number, size?: number, startDate?: string, endDate?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelTransactionDetailedDto>>;
    getDetailedCompense(page?: number, size?: number, startDate?: string, endDate?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/transactions/detailed/compense`;

        let params = new HttpParams();
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
